// Порядок разделов и страниц документации API. Из этого списка строятся маршруты, меню слева,
// переходы «назад/вперёд» и оглавление страницы — ссылки не размечаются вручную и не расходятся.
import type { ApiDocPage } from './types'
import { webhookApiDocs } from './pages/webhooks'
import { acquiringApiDocs } from './pages/acquiring'
import { integrationApiDocs } from './pages/integration'
import { catalogApiDocs } from './pages/catalog'
import { bonusApiDocs } from './pages/bonus'
import { ioApiDocs } from './pages/io'
import { feedApiDocs } from './pages/feed'

export interface ApiDocEntry {
  /** Адрес страницы без /api/. */
  path: string
  /** Имя маршрута. */
  name: string
  title: string
  page: ApiDocPage
}

export interface ApiDocSection {
  title: string
  pages: ApiDocEntry[]
}

export const apiDocSections: ApiDocSection[] = [
  {
    title: 'Настройка веб-хуков',
    pages: [
      { path: 'webhook/create', name: 'createWebhook', title: 'Создание вебхука', page: webhookApiDocs.createWebhook },
      { path: 'webhook/events', name: 'webhookEvents', title: 'Список событий', page: webhookApiDocs.webhookEvents },
      { path: 'webhook/update', name: 'updateWebhook', title: 'Обновление вебхука', page: webhookApiDocs.updateWebhook },
      { path: 'webhook/get', name: 'getWebhook', title: 'Показать вебхук', page: webhookApiDocs.getWebhook },
      { path: 'webhook/list', name: 'webhookList', title: 'Список вебхуков', page: webhookApiDocs.webhookList },
      { path: 'webhook/delete', name: 'deleteWebhook', title: 'Удаление вебхука', page: webhookApiDocs.deleteWebhook },
    ],
  },
  {
    title: 'Эквайринг',
    pages: [
      { path: 'acquiring/gates', name: 'acquiringGates', title: 'Список шлюзов', page: acquiringApiDocs.acquiringGates },
      { path: 'acquiring/ffd-keys', name: 'acquiringFfdKeys', title: 'Поля для фискализации', page: acquiringApiDocs.acquiringFfdKeys },
      { path: 'acquiring/create', name: 'createAcquiring', title: 'Создание эквайринга', page: acquiringApiDocs.createAcquiring },
      { path: 'acquiring/update', name: 'updateAcquiring', title: 'Обновление эквайринга', page: acquiringApiDocs.updateAcquiring },
      { path: 'acquiring/get', name: 'getAcquiring', title: 'Показать эквайринг', page: acquiringApiDocs.getAcquiring },
      { path: 'acquiring/list', name: 'acquiringList', title: 'Список эквайрингов', page: acquiringApiDocs.acquiringList },
      { path: 'acquiring/delete', name: 'deleteAcquiring', title: 'Удаление эквайринга', page: acquiringApiDocs.deleteAcquiring },
    ],
  },
  {
    title: 'Интеграции внешних систем',
    pages: [
      { path: 'integration/auth', name: 'integrationAuth', title: 'Вход в API интеграций', page: integrationApiDocs.integrationAuth },
      { path: 'integration/auth/settings', name: 'integrationAuthSettings', title: 'Настройка логина и пароля', page: integrationApiDocs.integrationAuthSettings },
      { path: 'integration/client/import', name: 'integrationClientImport', title: 'Импорт покупателя', page: integrationApiDocs.integrationClientImport },
      { path: 'integration/client/edit', name: 'integrationClientEdit', title: 'Редактирование покупателя', page: integrationApiDocs.integrationClientEdit },
      { path: 'integration/client/push', name: 'integrationCustomerPush', title: 'Уведомление покупателю', page: integrationApiDocs.integrationCustomerPush },
      { path: 'integration/order/import', name: 'integrationOrderImport', title: 'Импорт заказа', page: integrationApiDocs.integrationOrderImport },
      { path: 'integration/order/edit', name: 'integrationOrderEdit', title: 'Редактирование заказа', page: integrationApiDocs.integrationOrderEdit },
    ],
  },
  {
    title: 'Каталог',
    pages: [
      { path: 'catalog/import', name: 'catalogApiImport', title: 'Импорт каталога', page: catalogApiDocs.import },
      { path: 'catalog/delete', name: 'catalogApiDelete', title: 'Удаление из каталога', page: catalogApiDocs.delete },
      { path: 'catalog/export', name: 'catalogApiExport', title: 'Выгрузка каталога для сверки', page: catalogApiDocs.export },
      { path: 'catalog/sync', name: 'catalogApiSync', title: 'Полная синхронизация каталога', page: catalogApiDocs.sync },
      { path: 'catalog/webhooks', name: 'catalogApiWebhooks', title: 'Вебхуки через API интеграций', page: catalogApiDocs.webhooks },
    ],
  },
  {
    title: 'Бонусы',
    pages: [
      { path: 'bonus/balance', name: 'bonusBalance', title: 'Просмотр баланса', page: bonusApiDocs.bonusBalance },
      { path: 'bonus/info', name: 'bonusInfo', title: 'Просмотр информации', page: bonusApiDocs.bonusInfo },
      { path: 'bonus/add', name: 'bonusAdd', title: 'Начисление бонусов', page: bonusApiDocs.bonusAdd },
      { path: 'bonus/sub', name: 'bonusSub', title: 'Списание бонусов', page: bonusApiDocs.bonusSub },
    ],
  },
  {
    title: 'Выгрузка клиентов и торговые предложения',
    pages: [
      { path: 'io/clients', name: 'ioClients', title: 'Выгрузка клиентов', page: ioApiDocs.ioClients },
      { path: 'io/offers', name: 'ioOffers', title: 'Торговые предложения', page: ioApiDocs.ioOffers },
    ],
  },
  {
    title: 'Фид каталога',
    pages: [
      { path: 'feed/catalog', name: 'feedCatalog', title: 'Фид каталога из кабинета', page: feedApiDocs.feedCatalog },
    ],
  },
]

export const apiDocPages: ApiDocEntry[] = apiDocSections.flatMap(section => section.pages)
